import React, {Component} from 'react';
import {MultiSelect} from "../selects/MultiSelect";
import {APIClient} from "../../utils/APIClient";
import {API_URL} from "../../settings/local_settings";
import {LayoutSidebar} from "../../Layout";
import {ClientTabs} from "./ClientTabs";
import {SaveBar} from "../elements/SaveBar";
import {withRouterParams} from "../../utils/withRouterParams";
import { withTranslation } from 'react-i18next';

class ClientDashboUsersClass extends Component {
    constructor(props) {
        super(props);
        this.handleSelectedUsersChange = this.handleSelectedUsersChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.state = {
            users: null,
            selectedUserIds: null,
            savingChanges: false,
            hasChanges: false,
            userCanAssignClients: null
        }
    }

    componentDidMount() {
        this.getUsersOfClient();
        this.getClientData();
    }

    userCanChangeTeam() {
        return this.state.userCanAssignClients;
    }

    renderSaveBar() {
        if(!this.userCanChangeTeam())
            return;

        return <SaveBar onClick={this.handleSubmit} isSaving={this.state.savingChanges}
                        hasChanges={this.state.hasChanges}/>
    }

    render() {
        const { t } = this.props;
        return (
            <div className="app-content">
                <LayoutSidebar/>
                <section className="section-content">
                    <header className="section-header">
                        <h1 className="section-title">{this.state.name}</h1>
                    </header>
                    <ClientTabs clientId={this.clientId()}/>
                    <div className="section-body h-items">
                        <div className="section-body-item -wide box">
                            <header className="box-header">
                                <h2 className="box-title">{t('client_dashbo_users.users')}</h2>
                            </header>
                            {this.renderSelectUsersSection()}
                            {this.renderSaveBar()}
                        </div>
                    </div>
                </section>
            </div>
        );
    }

    renderSelectUsersSection() {
        return (
            <div className="form-row">
                {this.renderUsersMultiSelect()}
            </div>
        )
    }

    renderUsersMultiSelect() {
        const { t } = this.props;
        if (this.state.users !== null && this.state.selectedUserIds !== null) {
            return (
                <MultiSelect
                    readOnly={!this.userCanChangeTeam()}
                    items={this.state.users}
                    selectedItemIds={this.state.selectedUserIds}
                    onChange={this.handleSelectedUsersChange}
                />
            )
        } else {
            return <p>{t('common.loading')}</p>;
        }
    }

    clientId() {
        return this.props.match.params.id
    }

    // API

    getClientData() {
        new APIClient(this.getClientDataURL()).call('GET').then((response) => {
            if (response.status === 'ERROR') {
                alert(response.error_message);
            } else if (response.status === 'OK') {
                this.setState({
                    name: response.data.name,
                });
            }
        })
    }

    getClientDataURL() {
        return `${API_URL}client/${this.clientId()}`
    }

    dashboUsersURL() {
        return `${API_URL}client/${this.clientId()}/dashbo-users`
    }

    getUsersOfClient() {
        new APIClient(this.dashboUsersURL()).call('GET').then(response => {
            if (response.status === 'OK') {
                this.setState({
                    users: response.data.all_users,
                    selectedUserIds: response.data.client_user_ids,
                    userCanAssignClients: response.data.user_can_assign_clients
                })
            } else {
                alert(response['error_message'])
            }
        });
    }

    submitSelectedUsers() {
        this.setState({
            savingChanges: true
        });
        let data = {
            selected_user_ids: this.state.selectedUserIds
        };
        new APIClient(this.dashboUsersURL()).call('PUT', data).then(response => {
            if (response.status === 'OK') {
                this.setState({
                    hasChanges: false
                });
            } else {
                alert(response['error_message'])
            }
            this.setState({
                savingChanges: false
            });
        });
    }

    // Handlers

    handleSelectedUsersChange(selectedUserIds) {
        this.setState({
            hasChanges: true,
            selectedUserIds: selectedUserIds
        });
    }

    handleSubmit() {
        this.submitSelectedUsers()
    }
}

const ClientDashboUsers = withRouterParams(withTranslation()(ClientDashboUsersClass));
export default ClientDashboUsers;
